export default __webpack_public_path__ + "static/media/sapphire5.fda86259.jpg";